import { render, staticRenderFns } from "./dehumidifierBig.vue?vue&type=template&id=93168156&scoped=true"
import script from "./dehumidifierBig.vue?vue&type=script&lang=js"
export * from "./dehumidifierBig.vue?vue&type=script&lang=js"
import style0 from "./dehumidifierBig.vue?vue&type=style&index=0&id=93168156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93168156",
  null
  
)

export default component.exports